import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DtoAgentVM } from '../../../Model/agents/DtoAgentVM';
import { WorkshopService } from '../../../Services/workshop.service';
import { UserType } from '../../../Shared/Enums/UserType';
import { AuthService } from '../../../Shared/Services/auth.service';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import html2canvas from 'html2canvas'
import { SharedService } from '../../../Shared/Services/shared.service';

@Component({
  selector: 'app-view-client-workshop',
  templateUrl: './view-client-workshop.component.html',
  styleUrl: './view-client-workshop.component.scss'
})
export class ViewClientWorkshopComponent {
  WorkshopInfo: DtoAgentVM = {};
  private destroy$: Subject<boolean> = new Subject<boolean>();
  imgPath: string = environment.ImgUrl;
  @ViewChild('screen') screen!: ElementRef;
  @ViewChild('canvas') canvas!: ElementRef;
  @ViewChild('downloadLink') downloadLink!: ElementRef;
  constructor(private toastrService: CustomToastrService, private auth: AuthService, private router: Router,
    private api: WorkshopService, private spinner: NgxSpinnerService, private shared: SharedService) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Client])) {
      this.spinner.show();
      this.GetWorkShopByClient();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetWorkShopByClient() {
    if (this.auth.isAuthenticated([UserType.Client])) {
      this.api.GetWorkShopByClient()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            this.spinner.hide();
            if (data.isCompleted) {
              this.WorkshopInfo = data.result.payload[0];
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  Share = async () => {
    this.spinner.show();
    const captureElement = document.getElementById("capture");
    if (captureElement) {
      const canvas = await html2canvas(captureElement);

      canvas.toBlob(async (blob: any) => {
        const file = new File([blob], 'image.png', { type: blob.type });
        const blobUrl = URL.createObjectURL(file);
        //const imageData = canvas.toDataURL("image/png");
        // const imageUrl = URL.createObjectURL(blob);

        this.shared.SendWhatsAppMessage(blobUrl, true);
        this.spinner.hide();
      });
    }
  }
}
